import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleUserRelation } from '../../redux/actions/publicProfile';
import { getInitial } from '../../utils';

import styles from './streamerDetail.module.css';
import followingCheckIcn from '../../assets/following-check.svg';
import { getPopularStreamersList } from '../../redux/actions/auth';

const StreamerDetail = ({ item, checkBlockUnblock }) => {
  const dispatch = useDispatch();
  const thumbnail = item?.profile?.avatar;

  const [loading, setLoading] = useState(false);
  const [isFollowing, setIsFollowing] = useState(item?.relation?.isFollowing);
  const [isTotalFollowers, setIsTotalFollowers] = useState(
    item?.relation?.totalFollowers
  );

  const handleFollowAndUnfollowUser = async (item) => {
    if (loading) return;
    if (await checkBlockUnblock(item)) {
      return;
    }
    setLoading(true);
    const streamerProfile = false;
    let response = await dispatch(handleUserRelation(item, streamerProfile));
    if (response === 200 || response === 204) {
      setIsFollowing(!isFollowing);
      setIsTotalFollowers(
        isFollowing ? isTotalFollowers - 1 : isTotalFollowers + 1
      );
      dispatch(getPopularStreamersList());
      setTimeout(() => setLoading(false), 3000);
    } else {
      dispatch(getPopularStreamersList());
      setTimeout(() => setLoading(false), 3000);
    }
  };

  return (
    <>
      <div className={styles['streamer-wrapper']}>
        <Link to={`/profile/${item?.profile?.id}`}>
          <div className={styles['item-wrapper']}>
            <div>
              {thumbnail ? (
                <img src={thumbnail} alt='thumbnail' />
              ) : (
                <div className={styles['user-profile-icon']} data-initial-name>
                  {getInitial(item?.profile?.name)}
                </div>
              )}
            </div>
          </div>
        </Link>
        <div className={styles.title}>
          {item?.profile?.name?.split(' ')[0]}...
        </div>
        <span>{isTotalFollowers} Followers</span>
        <div
          onClick={() => handleFollowAndUnfollowUser(item)}
          id={loading ? `${styles['disable']}` : ''}
          className={
            isFollowing
              ? `${styles['follow']} ${styles['unfollow']}`
              : `${styles['follow']}`
          }
        >
          {isFollowing ? (
            <>
              {!loading && (
                <img
                  src={followingCheckIcn}
                  style={{ marginRight: '5px' }}
                  alt='Following'
                />
              )}
              {loading ? 'loading...' : 'Following'}
            </>
          ) : (
            <>{loading ? 'loading...' : '+ Follow'}</>
          )}
        </div>
      </div>
    </>
  );
};

export default StreamerDetail;
